export const truncateString = (
  string: string,
  lengthToTruncate: number = 76,
) => {
  return string.length > lengthToTruncate
    ? string.slice(0, Math.max(0, lengthToTruncate - 1)) + '&hellip;'
    : string;
};
